import styled from 'styled-components'

export const HeaderContainer = styled.header`
  background-color: ${(props) => (props.light ? '#fafafa' : '#4e4e4e')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  max-height: 107px;
  box-sizing: border-box;
`
export const PassagesText = styled.p`
  color: ${(props) => props.color};
  font-weight: bold;
  font-family: 'Flanders Art Sans', sans-serif;
  font-size: 36px;
  height: 43px;
  align-self: center;
  @media (max-width: 600px) {
    font-size: 20px;
    height: auto;
    margin: 0;
  }
`
export const CurrenTimeSpan = styled.span`
  font-family: 'Flanders Art Sans', sans-serif;
  font-size: 32px;
  font-weight: bold;
  color: ${(props) => (props.light ? '#2b3034' : '#fafafa')};
  @media (max-width: 600px) {
    font-size: 24px;
  }
  padding-left: 22px;
`
export const StyledLogo = styled.img`
  margin-right: ${(props) => props.light && '24px'};
  height: ${(props) => (props.light ? '100%' : '84px')};
  @media (max-width: 600px) {
    max-height: 50px;
    height: ${(props) => !props.light && '100%'};
  }
`
export const LogoAndTimeWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 6px;
`
export const DepartureTitle = styled.p`
  font-family: 'Flanders Art Sans', sans-serif;
  font-size: 32px;
  font-weight: bold;
  color: ${(props) => (props.light ? '#2b3034' : '#fafafa')};
  padding-top: 4px;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`
export const LoadingBorder = styled.div`
  height: 5px;
  width: 100%;
  background: ${(props) => (props.light ? '#e6e6e6' : '#666666')};
`
export const TimeSeparator = styled.span`
  @keyframes flash {
    0% {
      opacity: 1;
    }
    80% {
      opacity: 0;
    }
  }
  animation: flash 1800ms linear infinite;
`
